export const jsonp = function (url, data={}) {
  return new Promise((resolve, reject) => {
    const fn = `_fn_${new Date().getTime()}`
      window[fn] = data => resolve(data)
      let script = document.createElement('script')
      let query = Object.entries(data).map(a=>`${a[0]}=${a[1]}`).join('&')
      script.src = url + `?callback=${fn}&` + query
      script.onerror = () => reject('加载失败') 
      document.head.appendChild(script) 
      document.head.removeChild(script)
  }) 
}
